/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  var isGerman = window.location.pathname.indexOf('/de/') !== -1;
  document.body.classList.add(isGerman ? 'language-german' : 'language-english');
})();

(function () {


  document.querySelectorAll('.open-quick-view-btn').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    const productHandle = this.getAttribute('data-product-handle');
    

    fetch(`/products/${productHandle}?section_id=quick-view-product`)
      .then(response => response.text())
      .then(htmlContent => {

        const modalInner = document.querySelector('#quick-view-modal-inner');
        modalInner.innerHTML = htmlContent;
        

        document.querySelector('#quick-view-modal-overlay').classList.add('active');
        
        initQuickViewVariantTracking();
      })
      .catch(error => console.error('Error fetching Quick View:', error));
  });
});

function initQuickViewVariantTracking() {
  const modalInner = document.getElementById('quick-view-modal-inner');
  if (!modalInner) return;

  // Find all option dropdowns inside our freshly loaded modal template
  const selectors = modalInner.querySelectorAll('.single-option-selector');
  
  selectors.forEach(selector => {
    selector.addEventListener('change', () => {
      // 1. Gather all currently selected variant values in the modal
      const selectedValues = Array.from(selectors).map(el => el.value);
      
      // 2. Fetch the full product JSON data from Shopify securely
      const productHandle = modalInner.querySelector('.quick-view-modal-content').parentElement.parentElement.previousElementSibling?.getAttribute('data-product-handle') 
                            || window.location.pathname.split('/').pop(); 
      
      // A more robust way: fetch the product data object directly
      const currentProductId = modalInner.querySelector('.quick-view-modal-content').getAttribute('data-product-id');
      
      // To keep it lightning fast and vanilla JS, we look at the product's variant data
      // We will pull the master product JSON from Shopify's native client-side API
      fetch(`/products/${window.location.pathname.includes('/products/') ? window.location.pathname.split('/').pop() : 'trauringe-oval-gelbgold'}.js`)
        .then(res => res.json())
        .then(productData => {
          // Find the variant that matches the user's selected dropdown configuration
          const matchedVariant = productData.variants.find(variant => {
            return variant.options.every((optionVal, index) => optionVal === selectedValues[index]);
          });

          if (matchedVariant) {
            // Update the hidden master input ID that Shopify uses for checkout
            const hiddenInput = document.getElementById('qv-variant-id');
            if (hiddenInput) hiddenInput.value = matchedVariant.id;

            // Update the price display dynamically inside the modal
            const priceElement = modalInner.querySelector('.qv-price');
            if (priceElement) {
              // Format the price nicely (e.g., 159000 cents -> 1.590,00 €)
              const formattedPrice = (matchedVariant.price / 100).toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR'
              });
              priceElement.textContent = formattedPrice;
            }

            // Update Add to Cart button status based on stock availability
            const submitBtn = modalInner.querySelector('.qv-submit-btn');
            if (submitBtn) {
              if (matchedVariant.available) {
                submitBtn.disabled = false;
                submitBtn.textContent = `In den Warenkorb — ${(matchedVariant.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}`;
              } else {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Ausverkauft';
              }
            }
          }
        })
        .catch(err => console.error('Error updating variants:', err));
    });
  });
}

  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

